<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-card max-width="1000px">
        <v-toolbar color="primary" dark flat>
          <v-card-title>
            <span class="headline">User Account</span>
          </v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="user.alias"
                  label="Users Name"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="user.email"
                  label="E-mail"
                  required
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="user.fname"
                  label="First Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="user.lname"
                  label="Last Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="user.streetAddress"
                  label="Street Address"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="user.city" label="City"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="user.state" label="State"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="user.zip" label="Zip"></v-text-field>
              </v-col>
              <!-- <v-col cols="12">
                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'You must agree to continue!']"
                  label="Do you agree?"
                  required
                ></v-checkbox>
              </v-col>-->
              <v-col cols="12">
                <v-text-field
                  v-model="user.discord"
                  label="Discord"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mr-4"
              @click="UpdateProfile(user.user_id)"
              >Updated</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" top>
      Your Profile Successfully Updated
      <v-btn color="secondary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data: () => ({
    user: {
      fname: "",
      lname: "",
      email: "",
      alias: "",
      streetAddress: "",
      city: "",
      state: "",
      zip: ""
    },
    checkbox: false,
    valid: false,
    snackbar: false,
    timeout: 2000
  }),
  methods: {
    UpdateProfile(id) {
      let user = db.collection("users").doc(id);
      user.set(this.user).then((this.snackbar = true));
    }
  },
  created() {
    var vm = this;
    // let user = firebase.auth().currentUser
    firebase.auth().onAuthStateChanged(cred => {
      if (cred) {
        this.cred = cred;
        db.collection("users")
          .doc(this.cred.uid)
          .get()
          .then(function(doc) {
            if (doc.exists) {
              vm.user = doc.data();
            } else {
              // doc.data() will be undefined in this case
            }
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
          });
      } else {
        this.cred = null;
      }
    });
  }
};
</script>
